/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
(function ($) {
  function string_to_slug(str) {
    str = str.replace(/^\s+|\s+$/g, ""); // trim
    str = str.toLowerCase();

    // remove accents, swap � for n, etc
    var from = "�������������������������/_,:;";
    var to = "aaaaaaeeeeiiiioooouuuunc------";

    for (var i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
    }

    str = str
      .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
      .replace(/\s+/g, "-") // collapse whitespace and replace by -
      .replace(/-+/g, "-") // collapse dashes
      .replace(/^-+/, "") // trim - from start of text
      .replace(/-+$/, ""); // trim - from end of text

    return str;
  }

  $.fn.inView = function (inViewType) {
    //https://github.com/Mario-Duarte/inView

    //Calculates the viewport top and bottom position
    //  at the time of the call
    var offset = 0;
    var viewport = {};
    viewport.top = $(window).scrollTop();
    viewport.bottom = viewport.top + $(window).height();

    // Calculate element bouds positions
    var bounds = {};
    bounds.top = this.offset().top + offset;
    bounds.bottom = bounds.top + this.outerHeight();

    switch (inViewType) {
      case "bottomOnly":
        return (
          bounds.bottom <= viewport.bottom && bounds.bottom >= viewport.top
        );
      case "topOnly":
        return bounds.top <= viewport.bottom && bounds.top >= viewport.top;
      case "both":
        return bounds.top >= viewport.top && bounds.bottom <= viewport.bottom;
      default:
        // return ((bounds.top >= viewport.top) && (bounds.bottom <= viewport.bottom));
        return (
          bounds.bottom <= viewport.bottom && bounds.bottom >= viewport.top
        );
    }
  };

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var $window = $(window);
  var bodyDom = $("body");

  var Slider = {
    create: function (id) {
      var slider = new Swiper(id + " .swiper-container", {
        speed: 800,
        navigation: {
          nextEl: id + " .swiper-button-next",
          prevEl: id + " .swiper-button-prev",
        },
        pagination: {
          el: id + " .swiper-pagination",
          dynamicBullets: true,
        },
        watchOverflow: true,
        watchSlidesVisibility: true,
        autoplay: {
          delay: 5000,
        },
      });
    },
    initOffersSlider: function () {
      if ($(".offers-slider").length > 0) {
        // https://medium.com/@networkaaron/swiper-how-to-destroy-swiper-on-min-width-breakpoints-a947491ddec8
        var breakpoint = window.matchMedia("(min-width:62em)"); //992px

        // keep track of swiper instances to destroy later
        var mySwiper,
          swiperSlide = $(".offers-slider .swiper-slide"),
          nbSlides = swiperSlide.length,
          enableSwiper,
          breakpointChecker = function () {
            // if larger viewport and multi-row layout needed
            if (breakpoint.matches === true) {
              // clean up old instances and inline styles when available
              if (mySwiper !== undefined) {
                // enable swiper if there are more than 5 slides
                if (nbSlides > 5) {
                  return enableSwiper();
                }
                // destroy swiper
                mySwiper.destroy(true, true);
              }
              // add margin if swiper is undefined or disabled
              // swiperSlide.addClass('mr-xl-30');
              // or/and do nothing
              return;
              // else if a small viewport and single column layout needed
            } else if (breakpoint.matches === false) {
              // fire small viewport version of swiper
              return enableSwiper();
            }
          };

        enableSwiper = function () {
          mySwiper = new Swiper(".offers-slider .swiper-container", {
            speed: 800,
            watchOverflow: true,
            watchSlidesVisibility: true,
            slidesPerView: "auto",
            spaceBetween: 30,
            pagination: {
              el: ".swiper-pagination",
              type: "bullets",
              clickable: true,
            },
            autoplay: {
              delay: 5000,
            },
          });
        };

        // keep an eye on viewport size changes
        breakpoint.addListener(breakpointChecker);
        breakpointChecker();
      }
    },
  };

  var Map = {
    carte: null,
    polygonFrom: null,
    polygonTo: null,
    markerFrom: null,
    markerTo: null,
    mapDefaultCenter: [46.227638, 2.213749],
    mapDefaultZoom: 6,
    items: null,
    list: $(".store-locator-list .list"),
    locateAuthorization: null,
    searchForm: null,
    init: function () {
      if ($("#map").length) {
        Map.items = $(".retailer.with-address");
        Map.searchForm = $(".store-locator .search.form");
        // Use first retailer to center map.
        // if (Map.items.length > 0) {
        //   Map.mapDefaultCenter = [
        //     Map.items.first().data('lat'),
        //     Map.items.first().data('lng')
        //   ];
        //   Map.mapDefaultZoom = 16;
        // }
        Map.handleRetailerClick();
        Map.loadMap();
        Map.handleMap();
        Map.handleReset();
        if (Map.locateAuthorization) {
          Map.handleCurrentPosition();
        }

        $(".locate-me").click(function (event) {
          event.preventDefault();
          Map.handleCurrentPosition();
          Map.locateAuthorization = true;
        });
      }
    },
    loadMap: function () {
      var map = L.map("map", {
        // minZoom: 16,
        // maxZoom: 19,
        scrollWheelZoom: false,
      }).setView(Map.mapDefaultCenter, Map.mapDefaultZoom);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        maxZoom: 19,
      }).addTo(map);
      Map.carte = map;
    },
    handleMap: function () {
      var classIcon = L.icon({
        iconUrl: Config.marker_icon,
        iconSize: [27, 42],
        iconAnchor: [13, 42],
        // popupAnchor:  []
      });

      // L.NumberedDivIcon = L.Icon.extend({
      var ClassNumberedIcon = L.Icon.extend({
        options: {
          iconUrl: Config.marker_icon,
          number: "",
          shadowUrl: null,
          iconSize: [27, 42], // new L.Point(27, 42),
          iconAnchor: [13, 42], // new L.Point(13, 42),
          // popupAnchor: new L.Point(0, -33),
          className: "leaflet-div-icon",
        },

        createIcon: function () {
          var div = document.createElement("div");
          var img = this._createImg(this.options.iconUrl);
          var numdiv = document.createElement("div");
          numdiv.setAttribute("class", "number");
          numdiv.innerHTML = this.options.number || "";
          div.appendChild(img);
          div.appendChild(numdiv);
          this._setIconStyles(div, "icon");
          return div;
        },

        //you could change this to add a shadow like in the normal marker if you really wanted
        createShadow: function () {
          return null;
        },
      });

      var retailers = $(".retailer.with-address");
      retailers.each(function () {
        var retailer = $(this),
          _lat = retailer.data("lat"),
          _lng = retailer.data("lng");
        _markerId = retailer.data("marker-id");

        // var marker = L.marker([_lat, _lng], { icon: classIcon }).addTo(Map.carte).on('click', Map.handleMarkerClick);

        var marker = L.marker([_lat, _lng], {
          icon: new ClassNumberedIcon({ number: _markerId }),
        })
          .addTo(Map.carte)
          .on("click", Map.handleMarkerClick);
      });
    },
    handleMarkerClick: function (e) {
      // Click from markers.
      Map.carte.setView(e.latlng, 16);
      // Scroll to current retailer.
      var _currentRetailer = Map.items.filter(
        '[data-lat="' + e.latlng.lat + '"][data-lng="' + e.latlng.lng + '"]'
      );
      Map.setListScroll(_currentRetailer);
    },
    setListScroll: function (item) {
      setTimeout(function () {
        Map.list.animate(
          { scrollTop: Map.list.scrollTop() + item.position().top },
          200
        );
      }, 300);
    },
    handleRetailerClick: function () {
      // Click from retailer list.
      var triggerRetailer = $(".retailer.with-address");
      triggerRetailer.click(function (e) {
        // e.preventDefault();
        var _this = $(this),
          _lat = _this.data("lat"),
          _lng = _this.data("lng");

        Map.carte.setView([_lat, _lng], 16);
        // setTimeout(function(){
        //   Map.carte.setView([_lat, _lng], 16);
        // }, 500);
        Map.handleCountRetailers(true);
      });
    },
    handleCurrentPosition: function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          Map.carte.setView(pos, 11);
          Map.handleCountRetailers(true);
        });
      }
    },
    handleSearch: function () {
      var searchValue = $(
          ".store-locator .search #search-retailer-position"
        ).val(),
        searchPosition = searchValue.split(",");
      Map.carte.setView(searchPosition, 11);
      Map.handleCountRetailers(true);
    },
    handleReset: function () {
      var resetButton = $(".cancel");
      resetButton.click(function (e) {
        e.preventDefault();
        Map.carte.setView(Map.mapDefaultCenter, Map.mapDefaultZoom);
        Map.searchForm.removeClass("filtered");
        $(".store-locator .search #autocomplete").val("");
        // $( ".store-locator .search #search-retailer-position" ).val('');
        Map.handleCountRetailers(false);
      });
    },
    handleCountRetailers: function (check) {
      var bounds = Map.carte.getBounds(),
        count = 0,
        markers = Map.items,
        storeCount = $(".stores-count .count"),
        storeCountText = $(".stores-count .text");

      if (check) {
        markers.each(function () {
          var _this = $(this);
          if (
            bounds.contains([_this.data("lat"), _this.data("lng")]) === true
          ) {
            count++;
          }
        });
      } else {
        count = markers.length;
      }

      storeCount.text(count);
      if (count > 1) {
        storeCountText.text(Config.js_translations.magasins);
      } else if (count === 1) {
        storeCountText.text(Config.js_translations.magasin);
      } else if (count === 0) {
        storeCountText.text("");
        storeCount.text("");
      }
    },
  };

  var Fn = {
    tween: function (isTab) {
      var e = $;

      var l = function (t) {
          var a = 1,
            r = t.currentTarget.triggerElement().getAttribute("data-year"),
            i = ("" + r).split("");
          // console.log( 'r: '+r );
          TweenMax.to(".year-first", 0.3, {
            y: "-" + ((+i[0] + a) % 10) * 100 + "%",
          });
          TweenMax.to(".year-second", 0.6, {
            y: "-" + ((+i[1] + a) % 10) * 100 + "%",
          });
          TweenMax.to(".year-third", 0.8, {
            y: "-" + ((+i[2] + a) % 10) * 100 + "%",
          });
          TweenMax.to(".year-fourth", 1.1, {
            y: "-" + ((+i[3] + a) % 10) * 100 + "%",
          });
          $(".pagination__link").removeClass("is-active");
          $('.pagination__link[href="#' + r + '"]').addClass("is-active");
          $(".animate-history-item").removeClass("is-active");
          $('.animate-history-item[data-year="' + r + '"]').addClass(
            "is-active"
          );
        },
        c = new ScrollMagic.Controller({
          globalSceneOptions: {},
        });
      var r = '<ul class="paginations">',
        i = document.querySelectorAll(".animate-history-item");
      for (var t = 0; t < i.length; t++) {
        TweenMax.to(i[t], 0.8, {
          y: "0",
        });
        var n = i[t].getAttribute("data-year");
        r +=
          "<li class='pagination__item'><a class='pagination__link' href='#" +
          n +
          "'>" +
          n +
          "</a></li>";
        new ScrollMagic.Scene({
          triggerElement: i[t],
          duration: e(i[t]).outerHeight(),
        })
          .on("enter", l)
          .addTo(c);
      }
      function set(t) {
        t = new ScrollMagic.Controller({});
        new ScrollMagic.Scene({
          triggerElement: ".history-animation",
          duration: e(".history-animation").height() - 230,
        })
          .on("enter", function (e) {
            TweenMax.to(".js-year-container", 0.8, {
              opacity: 1,
              delay: 0.4,
            });
          })
          .addTo(t);
      }
      if (!isTab) {
        e(window).on("load", function () {
          set(t);
        });
      } else {
        set(t);
      }
      r += "</ul>";
      e("body").append(r);
      var s = function (t) {
        TweenMax.to(window, 1.5, {
          scrollTo: {
            y: e(t).offset().top - 320, // or 300 (old : 500)
            ease: Circ.easeOut,
          },
        });
      };
      e(document).on("click", ".paginations a[href^='#']", function (t) {
        var a = e(this).attr("href");
        if (e(a).length > 0) {
          t.preventDefault();
          s(a);
          if (!$("body").hasClass("single-wine")) {
            if (window.history && window.history.pushState) {
              history.pushState("", document.title, a);
            }
          }
        }
      });
    },
    goTo: function (target, speed, adapt) {
      // Scroll animation
      var toTop =
        typeof adapt !== "undefined" ? $(target).offset().top - $(".header").height() : $(target).offset().top;
      $("html, body").animate({ scrollTop: toTop }, speed);
    },
    header: function () {
      // Minify header on scroll
      var headerDom = $("header.header"),
        bodyDom = $("body"),
        Vwindow = $(window);

      function headerFixed() {
        if ($(window).width() > 1335) {
          $(window).scroll(function () {
            if (
              !bodyDom.hasClass("home") &&
              !bodyDom.hasClass("page-template-template-plan") &&
              !bodyDom.hasClass("error404")
            ) {
              if ($(this).scrollTop() > 40) {
                headerDom.addClass("fixed-top");
                // add padding top to show content behind navbar
                bodyDom.css("padding-top", headerDom.outerHeight() + "px");
              } else {
                headerDom.removeClass("fixed-top");
                bodyDom.css("padding-top", "0");
              }
            }
          });
        } else {
          // headerDom.addClass("fixed-top");
          if (
            !bodyDom.hasClass("home") &&
            !bodyDom.hasClass("page-template-template-plan") &&
            !bodyDom.hasClass("error404")
          ) {
            // add padding top to show content behind navbar
            bodyDom.css("padding-top", headerDom.outerHeight() + "px");
          }
        }
      }

      if (!bodyDom.hasClass("page-template-template-plan")) {
        window.onscroll = function () {
          var winScroll =
            document.body.scrollTop || document.documentElement.scrollTop;
          var height =
            document.documentElement.scrollHeight -
            document.documentElement.clientHeight;
          var videoHeight = $("section.video").outerHeight();
          // remove video height in homepage
          height = bodyDom.hasClass("home") ? height - videoHeight : height;
          winScroll = bodyDom.hasClass("home") ? winScroll - videoHeight : winScroll;
          var scrolled = (winScroll / height) * 100;
          document.getElementById("progress-bar").style.width = scrolled + "%";
        };
        // }

        headerFixed();

        Vwindow.resize(function () {
          headerFixed();
        });
      }

      if (bodyDom.hasClass("page-template-template-plan")) {
        // add padding top to show content behind navbar
        bodyDom.css("padding-top", headerDom.outerHeight() + "px");
      }
    },
    eventsIsotope: function () {
      var $grid = $(".grid").isotope({
        itemSelector: ".grid-item",
        // layoutMode: 'fitRows',
        percentPosition: true,
        masonry: {
          columnWidth: ".grid-sizer",
        },
      });

      var filters = [],
        html = $("html, body"),
        noResults = $(".no-results"),
        clearFilters = $(".clear-filters"),
        moreEvents = $(".seemore-events");

      function addFilter(filter) {
        if (filters.indexOf(filter) === -1) {
          filters.push(filter);
        }
      }

      function removeFilter(filter) {
        var index = filters.indexOf(filter);
        if (index !== -1) {
          filters.splice(index, 1);
        }
      }

      $(document).on("click", ".event-filter", function (e) {
        e.preventDefault();
        noResults.hide();
        var $target = $(e.currentTarget),
          filter = $target.attr("data-filter");
        $target.toggleClass("sidebar-link-active");
        clearFilters.removeClass("sidebar-link-active");
        var isChecked = $target.hasClass("sidebar-link-active");
        if (isChecked) {
          addFilter(filter);
        } else {
          removeFilter(filter);
        }
        $grid.isotope({ filter: filters.join(",") });
      });

      clearFilters.click(function (e) {
        e.preventDefault();
        noResults.hide();
        $(this).addClass("sidebar-link-active");
        $(".event-filter").each(function (filter) {
          $(this).removeClass("sidebar-link-active");
          var buttonfilter = $(this).attr("data-filter");
          removeFilter(buttonfilter);
        });
        $grid.isotope({ filter: "*" });
        moreEvents.parents(".row").show();
      });

      $grid.on("layoutComplete", function (event, filteredItems) {
        if (filteredItems.length === 0) {
          noResults.fadeIn("normal", function () {
            html.animate(
              {
                scrollTop:
                  $(".no-results").offset().top -
                  ($("header.header").height() + 15),
              },
              1000
            );
          });
        } else {
          html.animate(
            {
              scrollTop:
                $(".grid").offset().top - ($("header.header").height() + 15),
            },
            1000
          );
        }
        //on mobile & tablet portrait, close filter menu
        if ($(window).width() < 992) {
          $(".wrapper-sidebar").removeClass("active");
        }

        // show/hide seemore-events
        if (filteredItems.length > 6) {
          moreEvents.parents(".row").show();
        } else {
          moreEvents.parents(".row").hide();
        }
      });

      // See more events.
      moreEvents.click(function (e) {
        e.preventDefault();
        $(".event").each(function () {
          var _this = $(this);
          _this.removeClass("d-none");
        });
        $(".seemore-events").remove();
        $grid.isotope("layout");
      });
    },
    autocomplete: function () {
      // SEARCH
      var search = $(".store-locator .search #autocomplete");
      search
        .autocomplete({
          minLength: 0,
          source: Config.retailers_search_data,
          focus: function (event, ui) {
            search.val(ui.item.label);
            return false;
          },
          select: function (event, ui) {
            search.val(ui.item.label + ", " + ui.item.category);
            $(".store-locator .search #search-retailer-position").val(
              ui.item.value
            );
            Map.handleSearch();
            return false;
          },
        })
        .autocomplete("instance")._renderItem = function (ul, item) {
        return $("<li>")
          .append(
            "<div class='autocomplete-retailer-item'>" +
              item.label +
              " <span>" +
              item.category +
              "</span></div>"
          )
          .appendTo(ul);
      };
      // END SEARCH
    },
    checkSitckyContent: function () {
      // Enable sticky column on module-text-photo when necessary
      var target = $(".module-text-photo");

      target.each(function () {
        var _this = $(this);

        if (_this.length > 0) {
          var text = _this.find(".text-content"),
            textHeight = text.height(),
            sidebar = _this.find(".sidebar-ref"),
            img = sidebar.find(".img-content"),
            imgHeight = img.height();
          if (textHeight < imgHeight) {
            sidebar.addClass("no-sticky");
          }
        }
      });
    },
    hashActiveTab: function () {
      // Handle active tab from url hash
      var url = window.location.href;
      if (url.indexOf("#") > 0) {
        var anchor = url.substring(url.indexOf("#") + 1),
          anchorTab = anchor.split("-"),
          activeTab = anchor;

        if (anchorTab.length > 1) {
          activeTab = anchorTab[0];
          $('.nav[role="tablist"] a[href="#' + activeTab + '"]').tab("show");
          setTimeout(function () {
            $(".paginations a[href='#" + anchorTab[1] + "']").trigger("click");
          }, 500);
        } else {
          $('.nav[role="tablist"] a[href="#' + activeTab + '"]').tab("show");
        }
      }

      $('a[role="tab"]').on("click", function () {
        var newUrl;
        var hash = $(this).attr("href");
        newUrl = url.split("#")[0] + hash;
        history.replaceState(null, null, newUrl);
      });
    },
    menuGiscours: function () {
      var body = $("body"),
        menuContent = $(".menu-content"),
        breakpoint = window.matchMedia("(max-width:47.99)"),
        // screenheight = ( breakpoint.matches === true )?$(window).height():$(window).height()+50,
        menu = $(".main-menu"),
        menuBack = false,
        isMenuOpen = false,
        prevClicked = false,
        menuPro = $(".menu-pro");
      // console.log(screenheight);
      // console.log($(window).outerHeight());
      $(document).on("click", ".sliding-menu__nav", function () {
        // Get active menu and store it
        var caller = $(this).data("id");
        menuBack = $('ul[data-id="' + caller + '"]').find(
          ".sliding-menu__back"
        );
      });

      //Open menu
      $(".open-menu, .open-search, .close-menu").click(function (e) {
        e.preventDefault();
        var _this = $(this),
          menuContent = $(".menu-content");
        menuPro.removeClass("active");
        if (!isMenuOpen) {
          //Open Menu
          // document.documentElement.style.setProperty('--menuHeight', screenheight+'px');
          body.addClass("menu-active");
          // _this.addClass('active-menu-item');
          isMenuOpen = true;
          if (_this.hasClass("open-search")) {
            menuContent.addClass("active-search");
          } else if (_this.hasClass("open-menu")) {
            menuContent.removeClass("active-search");
            if (menuBack) {
              // close previous opened sub menu
              menuBack.trigger("click");
            }
          }
        } else {
          if (prevClicked !== _this.attr("id")) {
            //Switch state
            if (_this.hasClass("open-search")) {
              menuContent.addClass("active-search");
            } else if (_this.hasClass("open-menu")) {
              menuContent.removeClass("active-search");
            }
          } else if (prevClicked === _this.attr("id")) {
            //Close menu
            body.removeClass("menu-active");
            // _this.removeClass('active-menu-item');
            // document.documentElement.style.setProperty('--menuHeight', '100%');
            // reset menu display to default
            setTimeout(function () {
              if (menuBack) {
                // close previous opened sub menu
                menuBack.trigger("click");
              }
              // Reset menu to default
              // menuContent.removeClass('active-search');
            }, 800);
            isMenuOpen = false;
          }
        }

        prevClicked = _this.attr("id");
      });

      //Open pro registration menu
      $(".open-menu-pro").click(function (e) {
        e.preventDefault();
        if (isMenuOpen === false) {
          $("#open-menu").trigger("click");
        }
        menuPro.addClass("active");
      });

      //Close pro registration menu
      $(".close-menu-pro").click(function (e) {
        e.preventDefault();
        menuPro.removeClass("active");
      });

      // refresh menu on resize
      var Vwindow = $(window),
        cachedWidth = Vwindow.width();

      // Vwindow.resize(function(){
      //   var newWidth = Vwindow.width();
      //   if(newWidth !== cachedWidth){
      //     cachedWidth = newWidth;
      //     var screenheight = $(window).height();
      //     if(body.hasClass('menu-active')){
      //       document.documentElement.style.setProperty('--menuHeight', screenheight+'px');
      //     }
      //   }
      // });

      // https://labs.danielcardoso.net/sliding-menu/
      $("#menu").slidingMenu({ backLabel: Config.js_translations.retour });
    },
    moduleFullWidth: function () {
      $(".img-to-scale").on("inview", function (event, isInView) {
        var _this = $(this);
        if (isInView) {
          _this.addClass("active");
        } else {
          _this.removeClass("active");
        }
      });
    },
    fakeShare: function () {
      $(".share-wrapper .icons a").click(function (e) {
        e.preventDefault();
        var $link = $(this);
        var href = $link.attr("href");
        var network = $link.attr("data-network");

        var networks = {
          facebook: { width: 600, height: 300 },
          twitter: { width: 600, height: 254 },
          google: { width: 515, height: 490 },
          linkedin: { width: 600, height: 473 },
          pinterest: { width: 600, height: 600 },
        };

        var x = screen.width / 2 - networks[network].width / 2;
        var y = screen.height / 2 - networks[network].height / 2 - 200;

        var popup = function (network) {
          var options = "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,";
          window.open(
            href,
            "",
            options +
              "height=" +
              networks[network].height +
              ",width=" +
              networks[network].width +
              ",left=" +
              x +
              ",top=" +
              y
          );
        };

        popup(network);
      });
    },
    fadeDate: function () {
      $(".paginations").css("visibility", "hidden");
      var elementHeight = $(".paginations").height();
      var startOffset = $(".paginations").offset();
      var fadeComplete = false;
      $(window).scroll(function () {
        var currentOffset = $(".paginations").offset();
        // console.log(elementHeight);
        // console.log(startOffset.top);
        // console.log(currentOffset.top);
        if (
          currentOffset.top > startOffset.top + elementHeight * 2 &&
          fadeComplete === false
        ) {
          $(".paginations").css("visibility", "visible");
          $(".paginations").hide();
          $(".paginations").fadeIn("slow");
          fadeComplete = true;
        }
      });
    },
    download_file: function (fileURL, fileName) {
      // for non-IE
      if (!window.ActiveXObject) {
        var save = document.createElement("a");
        save.href = fileURL;
        save.target = "_blank";
        var filename = fileURL.substring(fileURL.lastIndexOf("/") + 1);
        save.download = fileName || filename;
        if (
          navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
          navigator.userAgent.search("Chrome") < 0
        ) {
          document.location = save.href;
          // window event not working here
        } else {
          var evt = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: false,
          });
          save.dispatchEvent(evt);
          (window.URL || window.webkitURL).revokeObjectURL(save.href);
        }
      }

      // for IE < 11
      else if (!!window.ActiveXObject && document.execCommand) {
        var _window = window.open(fileURL, "_blank");
        _window.document.close();
        _window.document.execCommand("SaveAs", true, fileName || fileURL);
        _window.close();
      }
    },
  };

  var Modules = {
    init: function () {
      Modules.initOffers();
      Modules.initQuestion();
      Modules.initHoverOffer();
      Modules.initHoverFavoriteWine();
    },
    initQuestion: function () {
      var visit = $(".visit-us");
      visit.find("a.square").hover(
        function () {
          $(this).parents(".visit-us").addClass("hover");
        },
        function () {
          $(this).parents(".visit-us").removeClass("hover");
        }
      );
    },
    initHoverOffer: function () {
      var offer = $(".offers .offer");
      offer.find(".btn-default").hover(
        function () {
          $(this).parents(".offer").addClass("hover");
        },
        function () {
          $(this).parents(".offer").removeClass("hover");
        }
      );
    },
    initHoverFavoriteWine: function () {
      $(".favorite-wine")
        .find("a.castle")
        .hover(
          function () {
            $(this).parents(".favorite-wine").addClass("active");
          },
          function () {
            $(this).parents(".favorite-wine").removeClass("active");
          }
        );
    },
    initOffers: function () {
      // Display / hide tab content.
      $(".filter-tab").click(function (e) {
        e.preventDefault();
        var _this = $(this),
          _tab = _this.data("tab");

        if (_this.hasClass("active")) {
          // Hide current tab.
          $('.filter-tab[data-tab="' + _tab + '"]').removeClass("active");
          $('.filter-tab-content[data-tab="' + _tab + '"]').slideUp();
        } else {
          // Sync tabs.
          $('.filter-tab[data-tab!="' + _tab + '"]').removeClass("active");
          $('.filter-tab[data-tab="' + _tab + '"]').addClass("active");
          // Sync tab content.
          $('.filter-tab-content[data-tab!="' + _tab + '"]').slideUp();
          $('.filter-tab-content[data-tab="' + _tab + '"]').slideDown();
        }
      });
      Slider.initOffersSlider();
    },
  };

  var Ajax = {
    init: function () {
      $(document).on("click", ".articles-loadmore", function (e) {
        e.preventDefault();
        var _this = $(this);
        Ajax.loadMore(_this, "loadmoreArticles", ".article-results", _this);
      });

      // Generic 'consent' checkbox.
      $(document).on("click", ".box-consent", function (e) {
        var form = $(this).closest("form"),
          submit = form.find(".submit");
        if ($(this).prop("checked")) {
          submit.removeClass("no-consent");
          form.find(".custom-checkbox").removeClass("remind-custom-consent");
        } else {
          submit.addClass("no-consent");
        }
      });

      // Submit newsletter.
      $(document).on("click", ".newsletter-form .submit", function (e) {
        // .block-newsletter
        e.preventDefault();
        var form = $(this).parents(".newsletter-form"),
          email = form.find("#newsletter-email").val();
        if (
          email !== "" &&
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
        ) {
          form.find(".email-invalid").addClass("d-none");
          if (!$(this).hasClass("no-consent")) {
            Ajax.subscribeNewsletter(email, form);
          } else {
            form.find(".custom-checkbox").addClass("remind-custom-consent");
          }
        } else {
          form.find(".email-invalid").removeClass("d-none");
        }
      });
    },
    subscribeNewsletter: function (email, form) {
      var loader = $(".loader"),
        data = {
          action: "subscribeNewsletter",
          email: email,
        };

      $.ajax({
        url: Config.ajax_url,
        data: data,
        type: "POST",
        beforeSend: function (xhr) {
          loader.show();
        },
        success: function (response) {
          if (response === "200") {
            form.addClass("d-none");
            $(".newsletter .confirmation").removeClass("d-none");
          } else {
            console.log("error"); // TODO
          }
          loader.hide();
        },
      }); // end Ajax
    },
    loadMore: function (button, ajaxAction, listID, loader) {
      var currentPage = button.attr("data-current-page"),
        maxNumPages = button.attr("data-max-num-pages"),
        exclude = button.attr("data-exclude"),
        data = {
          action: ajaxAction,
          current_page: currentPage,
          exclude: exclude,
          is_ajax: true,
        };

      button.attr("disabled", "disabled");

      $.ajax({
        url: Config.ajax_url,
        data: data,
        type: "POST",
        beforeSend: function (xhr) {
          loader.addClass("active");
        },
        success: function (data) {
          if (data) {
            $(listID).append(data);

            currentPage = parseInt(currentPage) + 1;
            button.attr("data-current-page", currentPage);

            button.removeAttr("disabled");
            loader.removeClass("active");

            if (currentPage >= maxNumPages) {
              button.remove();
            }
          } else {
            button.remove(); // if no data, remove the button as well
          }
        },
      }); // end Ajax
    },
  };

  var Booking = {
    current_date: null,
    tourist_tax_input: ".wc-pao-addon-taxe-de-sejour input",
    tourist_tax_input_en: ".wc-pao-addon-tourist-tax input",
    init: function () {
      // Scroll from booking button.
      $(".btn-book").click(function (e) {
        e.preventDefault();
        setTimeout(function () {
          var section = $("#booking");
          $("html,body").animate(
            { scrollTop: section.offset().top - 135 },
            "slow"
          );
        }, 500);
      });
      // $(".wc-pao-addons-container").appendTo("#book-left");
      $(".wc-pao-addons-container").addClass("row");
      // Hide options fields.
      // Booking.displayOrHideSelectOptions();
      Booking.initListeners();
      Booking.handleMoreLess();
      Booking.handleCustomSelect();
    },
    handleMoreLess: function () {
      $(document).on("click", ".quantity_wrapper a", function (event) {
        event.preventDefault();
        var _this = $(this),
          qty = _this.parents(".quantity_wrapper").find("input"),
          current_quantity = parseInt(qty.val()),
          new_quantity,
          step = parseInt(qty.attr("step")),
          max = qty.attr("max"),
          min = qty.attr("min");

        if (_this.hasClass("more")) {
          if (max.length) {
            if (current_quantity < max) {
              new_quantity = current_quantity + step;
            }
          } else {
            new_quantity = current_quantity + 1;
          }
          Booking.tourist_tax_multiplier = new_quantity;
        } else if (_this.hasClass("less")) {
          if (min.length) {
            if (current_quantity > min) {
              new_quantity = current_quantity - step;
            }
          } else {
            new_quantity = current_quantity - 1;
          }
          Booking.tourist_tax_multiplier = new_quantity;
        }
        if (new_quantity > 0) {
          qty.val(new_quantity).change();
          // Update tourist tax multiplier after nb people changes.
          Booking.updateTouristTaxMultiplier();
        }
      });
    },
    handleCustomSelect: function () {
      var cSelect = $(".c-select");
      if (cSelect.length > 0) {
        cSelect.selectric({
          width: 300,
          // expandToItemText : true,
          // onChange: function() {
          // }
        });
      }
    },
    displayOrHideSelectOptions: function (options) {
      var _addonMorning = $(".wc-pao-addon-heure-darrivee-matin"),
        _addonMorningSelect = _addonMorning.find("select"),
        _addonAfternoon = $(".wc-pao-addon-heure-darrivee-apres-midi"),
        _addonAfternoonSelect = _addonAfternoon.find("select");

      if (options === "matin") {
        // console.log('display matin selector');
        _addonMorning.show();
        _addonAfternoon.hide();
        _addonMorningSelect.prop("disabled", false).prop("required", true);
        _addonAfternoonSelect.prop("disabled", true).prop("required", false);
      } else if (options === "apres-midi") {
        // console.log('display apres-midi selector');
        _addonMorning.hide();
        _addonAfternoon.show();
        _addonMorningSelect.prop("disabled", true).prop("required", false);
        _addonAfternoonSelect.prop("disabled", false).prop("required", true);
      } else {
        // console.log('hide options selectors');
        _addonMorning.hide();
        _addonAfternoon.hide();
        _addonMorningSelect.prop("disabled", true).prop("required", false);
        _addonAfternoonSelect.prop("disabled", true).prop("required", false);
      }
    },
    resetSelectOptions: function () {
      var _morningSelect = $(
        ".wc-pao-addon-heure-darrivee-matin .wc-pao-addon-select"
      );
      _morningSelect.val(_morningSelect.find("option:first").val());
      var _afternoonSelect = $(
        ".wc-pao-addon-heure-darrivee-apres-midi .wc-pao-addon-select"
      );
      _afternoonSelect.val(_afternoonSelect.find("option:first").val());
    },
    initListeners: function () {
      // On click (date picker)
      $(".wc-bookings-date-picker").on(
        "date-selected",
        function (event, fdate) {
          setTimeout(function () {
            // Update tourist tax multiplier after calendar changes.
            Booking.updateTouristTaxMultiplier();
          }, 500);
        }
      );

      // On click (date picker)
      // $("#wc-bookings-booking-form > fieldset").on('date-selected', function( event, fdate ) {
      //   // Reset & hide dropdowns only if we select an other date.
      //   if (Booking.current_date !== fdate) {
      //     Booking.resetSelectOptions();
      //     Booking.displayOrHideSelectOptions();
      //   }
      //   Booking.current_date = fdate;
      //
      //   setTimeout(function () {
      //
      //     var _blockPicker = $('#wc-bookings-booking-form > div.form-field.form-field-wide > ul'),
      //         _blocks = _blockPicker.find('.block');
      //
      //     _blocks.each(function( index ) {
      //       var _this = $(this);
      //       _this.on('click', function() {
      //         var _block = _this.data('block');
      //         if (_block === 1100) { // Morning (tmp 11h)
      //           Booking.displayOrHideSelectOptions('matin');
      //         } else if (_block === 1500) { // Afternoon (tmp 15h)
      //           Booking.displayOrHideSelectOptions('apres-midi');
      //         } else {
      //           Booking.displayOrHideSelectOptions();
      //         }
      //         Booking.resetSelectOptions();
      //       });
      //     });
      //   }, 1000);
      // });
    },
    updateTouristTaxMultiplier: function () {
      // Get necessary data then calculate tourist tax.
      var _nbDays = $(".bookable-range").length,
        _nbNights = _nbDays > 1 ? _nbDays - 1 : 1,
        _nbPersons = $(".wc_bookings_field_persons input").val(),
        _taxMultiplier = _nbNights * _nbPersons;
      $(Booking.tourist_tax_input).val(_taxMultiplier).change();
      $(Booking.tourist_tax_input_en).val(_taxMultiplier).change();
    },
  };

  $.extend($.validator.messages, {
    required: Config.js_translations.required,
    remote: Config.js_translations.remote,
    email: Config.js_translations.email,
    url: Config.js_translations.url,
    date: Config.js_translations.date,
    equalTo: Config.js_translations.equalTo,
    email2: Config.js_translations.email2,
  });

  var Account = {
    init: function () {
      Account.handleProButtons();
      Account.doFormAjax();
      Account.doLostpassword();
    },

    handleProButtons: function () {
      var loadRegister = $(".load-register"),
        loadConnect = $(".load-connect"),
        loadLostPassword = $(".load-lost-password"),
        connect = $(".connect"),
        register = $(".register"),
        lostPassword = $(".lost-password");

      loadRegister.click(function (e) {
        e.preventDefault();
        register.show();
        connect.hide();
        lostPassword.hide();
      });

      loadConnect.click(function (e) {
        e.preventDefault();
        console.log("loadConnect");
        register.hide();
        connect.show();
        lostPassword.hide();
      });

      loadLostPassword.click(function (e) {
        e.preventDefault();
        console.log("loadLostPassword");
        register.hide();
        connect.hide();
        lostPassword.show();
      });
    },

    doLostpassword: function () {
      if ($("#forgot_password").length) {
        $("#forgot_password").validate();
      }
      // Perform AJAX forget password on form submit
      $("form#forgot_password").on("submit", function (e) {
        if (!$(this).valid()) {
          return false;
        }
        var _this = $(this),
          loader = _this.find(".spinner"),
          formMessage = _this.find(".form-message"),
          connect = $(".connect"),
          register = $(".register"),
          lostPassword = $(".lost-password");

        formMessage.text("").removeClass("error success");
        $.ajax({
          type: "POST",
          dataType: "json",
          url: Config.ajax_url,
          data: {
            action: "ajaxforgotpassword",
            user_login: $("#user_login").val(),
            security: $("#forgotsecurity").val(),
          },
          beforeSend: function () {
            loader.show();
          },
          success: function (data) {
            loader.hide();
            if (data.success === true) {
              formMessage.addClass("success");
              setTimeout(function () {
                register.hide();
                connect.show();
                lostPassword.hide();
              }, 6000);
            } else if (data.error === true) {
              formMessage.addClass("error");
            }
            formMessage.text(data.message);
          },
        });
        e.preventDefault();
        return false;
      });
    },

    doFormAjax: function () {
      if ($("#register, #update").length) {
        jQuery.validator.addMethod(
          "password",
          function (value, element) {
            var result =
              this.optional(element) ||
              (value.length >= 7 && /\d/.test(value) && /[a-z]/i.test(value));
            if (!result) {
              // element.value = "";
              var validator = this;
              setTimeout(function () {
                validator.blockFocusCleanup = true;
                element.focus();
                validator.blockFocusCleanup = false;
              }, 1);
            }
            return result;
          },
          Config.js_translations.passwordformat
        );

        $("#register").validate({
          messages: {
            password2: {
              required: " ",
              equalTo: Config.js_translations.equalTo,
            },
          },
          errorPlacement: function (error, element) {
            if (element.attr("name") === "checkbox-consent") {
              element.closest("label").append(error);
            } else {
              error.insertAfter(element);
            }
          },
        });

        $("#update-password").click(function () {
          var passFields = $(".show-password");
          if ($(this).prop("checked")) {
            passFields.removeClass("d-none");
          } else {
            passFields.addClass("d-none");
          }
        });

        // $("#update").validate(
        //   {
        //     rules:{
        //       tel:{
        //         required:'#reminder:checked'
        //       },
        //       signonpassword:{
        //         required:'#update-password:checked'
        //       }
        //     },
        //     messages: {
        //       password2: {
        //         required: " ",
        //         equalTo: Config.js_translations.equalTo
        //       },
        //       tel :  Config.js_translations.phoneRappel,
        //     }
        //   }
        // );
      } else if ($("#login").length) {
        $("#login").validate();
      }

      $(document).on(
        "submit",
        "form#login, form#register, form#update",
        function (e) {
          e.preventDefault();

          if (!$(this).valid()) {
            return false;
          }

          var _this = $(this),
            loader = _this.find(".spinner-border"),
            formMessage = _this.find(".form-message");

          formMessage.text("").removeClass("error success");

          datas = "";

          if (_this.attr("id") === "register") {
            datas = {
              action: "register_user",
              firstname: $("#firstname").val(),
              lastname: $("#lastname").val(),
              password: $("#signonpassword").val(),
              email: $("#email").val(),
              tel: $("#tel").val(),
              job: $("#job").val(),
              security: $("#signonsecurity").val(),
            };
          } else if (_this.attr("id") === "update") {
            datas = {
              action: "update_user",
              userid: $("#userid").val(),
              firstname: $("#firstname").val(),
              lastname: $("#lastname").val(),
              password: $("#signonpassword").val(),
              email: $("#email").val(),
              tel: $("#tel").val(),
              job: $("#job").val(),
              security: $("form#update #security").val(),
            };
          } else if (_this.attr("id") === "login") {
            datas = {
              action: "login_user",
              username: $("form#login #username").val(),
              password: $("form#login #password").val(),
              security: $("form#login #security").val(),
            };
          }

          $.ajax({
            type: "POST",
            dataType: "json",
            url: Config.ajax_url,
            data: datas,
            beforeSend: function () {
              loader.show();
            },
            success: function (data) {
              loader.hide();
              if (data.loggedin === true) {
                if (
                  _this.attr("id") === "register" ||
                  _this.attr("id") === "login"
                ) {
                  setTimeout(function () {
                    document.location.href = Config.redirect_pro_url;
                  }, 800);
                } else if (_this.attr("id") === "update") {
                  setTimeout(function () {
                    formMessage.slideUp("slow");
                  }, 5000);
                }
                formMessage.addClass("success");
              } else {
                formMessage.addClass("error");
              }
              formMessage.text(data.message);
            },
          });
          e.preventDefault();
        }
      );
    },
  };

  var EvoCalendar = {
    // DEBUG_EVO
    currentDate: new Date(),
    currentMonth: null,
    currentMonthName: null,
    currentYear: null,
    activeEvents: [],
    init: function (calendarId) {
      var _currentMonthName = EvoCalendar.currentDate.toLocaleString("en-GB", {
        month: "long",
      });
      EvoCalendar.currentMonthName = _currentMonthName;
      EvoCalendar.currentMonth = EvoCalendar.currentDate.getMonth() + 1;
      EvoCalendar.currentYear = EvoCalendar.currentDate.getFullYear();
      // console.log('currentDate : ' + EvoCalendar.currentDate);
      // console.log('month : ' + EvoCalendar.currentMonth + ', month (name) : ' + EvoCalendar.currentMonthName + ', year : ' + EvoCalendar.currentYear);

      $("#" + calendarId).evoCalendar({
        // settingName: "hello",
        calendarEvents: [],
      });
      EvoCalendar.getEvents(calendarId); // NOTE : get events from PHP ? (first call)
    },
    initListeners: function (calendarId) {
      var _calendar = $("#" + calendarId);

      _calendar.on("selectDate", function (e) {
        console.log("selectDate");
      });

      _calendar.on("selectMonth", function (e) {
        EvoCalendar.currentMonth = e.target.evoCalendar.$active.month + 1;
        var _tmpDate = new Date(
            EvoCalendar.currentMonth + "/1/" + e.target.evoCalendar.$active.year
          ),
          _tmpDateMonthName = _tmpDate.toLocaleString("en-GB", {
            month: "long",
          });
        EvoCalendar.currentMonthName = _tmpDateMonthName;
        // console.log('selectMonth : ' + EvoCalendar.currentMonth + ' (' + EvoCalendar.currentMonthName + ')');
        EvoCalendar.getEvents(calendarId);
      });

      _calendar.on("selectYear", function (e) {
        EvoCalendar.currentYear = e.target.evoCalendar.$active.year;
        // console.log('selectYear : ' + EvoCalendar.currentYear);
        // console.log(e);
        EvoCalendar.getEvents(calendarId);
      });

      _calendar.on("selectEvent", function (e) {
        console.log("selectEvent");
      });
    },
    getEvents: function (calendarId) {
      var _startDateStr =
          EvoCalendar.currentMonth + "/1/" + EvoCalendar.currentYear,
        _startDate = new Date(_startDateStr),
        _lastDayOfMonth = new Date(
          _startDate.getFullYear(),
          _startDate.getMonth() + 1,
          0
        ),
        _endDateStr =
          EvoCalendar.currentMonth +
          "/" +
          _lastDayOfMonth.getDate() +
          "/" +
          EvoCalendar.currentYear;
      // console.log('_startDateStr : ' + _startDateStr);
      // console.log('_endDateStr : ' + _endDateStr);

      EvoCalendar.ajaxGetEvents(calendarId, _startDateStr, _endDateStr);
    },
    ajaxGetEvents: function (calendarId, from, to) {
      var loader = $(".loader"),
        data = {
          action: "getOutlookEvents",
          calendar: calendarId,
          from: from,
          to: to,
          lib: "evocalendar",
        };

      $.ajax({
        url: Config.ajax_url,
        data: data,
        type: "POST",
        beforeSend: function (xhr) {
          loader.show();
        },
        success: function (response) {
          // console.log(response.data.code);
          // console.log(response);

          if (response.data.code === "200") {
            // var eventsToRemove = response.data.del;
            var eventsToAdd = response.data.events;
            eventsToAdd.forEach(function (event) {
              var _index = EvoCalendar.activeEvents.indexOf(event.id);
              if (_index === -1) {
                EvoCalendar.activeEvents.push(event.id);
                $("#" + calendarId).evoCalendar("addCalendarEvent", event);
                // console.log('xx add event : ' + event.id);
              }
            });

            // Remove events. (to avoid duplications)
            // var eventsToRemove = response.data.del;
            // eventsToRemove.forEach(function(eventId){
            //   var _index = EvoCalendar.activeEvents.indexOf(eventId);
            //   if (_index >= 0) {
            //     EvoCalendar.activeEvents.splice(_index, 1);
            //     $("#"+calendarId).evoCalendar("removeCalendarEvent", eventId);
            //     // console.log('xx remove ' + eventId);
            //   }
            // });

            // Add events.
            // var eventsToAdd = response.data.events;
            // eventsToAdd.forEach(function(event){
            //   EvoCalendar.activeEvents.push(event.id);
            //   $("#"+calendarId).evoCalendar('addCalendarEvent', event);
            //   // console.log('xx add ' + event.id);
            // });
            // $("#"+calendarId).evoCalendar('addCalendarEvent', response.data.events);
          } else {
            console.log("error"); // TODO
          }
          loader.hide();
        },
      }); // end Ajax
    },
  };

  var Fullcalendar = {
    // DEBUG_FULL
    calendar: null,
    trackingAjaxCalls : [],
    init: function (calendarId) {
      // init
      var calendarEl = document.getElementById(calendarId);
      Fullcalendar.calendar = new FullCalendar.Calendar(calendarEl, {
        initialView: "dayGridMonth",
        locale: "fr",
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
        },
        dayMaxEvents: 4,
        firstDay: 1, // Monday
        dayHeaderFormat: { weekday: 'short' }, // Default
        // dayHeaderFormat: { weekday: "long" }, // like 'Monday', for day views
        weekNumbers: true,
        weekNumberCalculation: "local",
        weekText: "S",
        weekTextLong: "Semaine",
        aspectRatio: 1.75,
        editable: false,
        handleWindowResize: true,
        // draggable: false,
        eventMouseEnter: function (info) {
          // console.log('Event: ' + info.event.title);
          // $(info.el).tooltip({ title: info.event.title });
          // $(info.el).tooltip({ title: info.event.extendedProps.description });
        },
        eventClick: function (info) {
          console.log(info.event);
          $('#modalBody > #title').text(info.event.title);

          var date = Fullcalendar.calendar.formatDate(info.event.start, {
            month: 'long',
            year: 'numeric',
            day: 'numeric'
          });
          $('#modalWhen').text(date);
          $('#calendarModal').modal();
          // console.log('Event: ' + info.event.title);
          // console.log('Desc: ' + info.event.extendedProps.description);
          // console.log('***************');
          // info.el.style.borderColor = 'red'; // Test
          // $(info.el).tooltip({ title: info.event.title });
          // $(info.el).tooltip({ title: info.event.extendedProps.description });

          var _extendedProps = info.event.extendedProps;
          $('#modalDesc').html(_extendedProps.description);
          if (_extendedProps.location !== '') {
            $('#location').removeClass('d-none');
          } else {
            $('#location').addClass('d-none');
          }
          $('#modalWhere').text(_extendedProps.location);
        },
      });

      var loader = $(".loader");
      loader.hide();

      // Fullcalendar.calendar.setOption('locale', 'fr');

      Fullcalendar.calendar.render();
      Fullcalendar.initListeners();
      // Fullcalendar.getEvents('init'); // Display current month events from AJAX

      // Display current month events from PHP
      if (Config.cbooking_outlook_events.length > 0) {
        var currentMonth = $('#fc-dom-1').html();
        Config.cbooking_outlook_events.forEach(function (event) {
          Fullcalendar.calendar.batchRendering(function () {
            Fullcalendar.calendar.changeView("dayGridMonth");
            Fullcalendar.calendar.addEvent(event);
          });
        });
        Fullcalendar.trackingAjaxCalls.push(currentMonth);
      }
    },
    initListeners: function () {
      // initListeners
      Fullcalendar.calendar.on("dateClick", function (info) {
        // console.log("clicked on " + info.dateStr);
        Fullcalendar.calendar.changeView("timeGridDay", info.dateStr);
      });

      $(".fc-prev-button").on("click", function (e) {
        var _dayGridMonthButton = $('.fc-dayGridMonth-button');
        if (_dayGridMonthButton.hasClass('fc-button-active')) {
          Fullcalendar.getEvents('prev');
        }
      });

      $(".fc-next-button").on("click", function (e) {
        var _dayGridMonthButton = $('.fc-dayGridMonth-button');
        if (_dayGridMonthButton.hasClass('fc-button-active')) {
          Fullcalendar.getEvents('next');
        }
      });
    },
    getEvents: function (context) {

      if (context === 'prev' || context === 'next') { // Navigation

        // console.log('####### prev/next context');

        var _currentMonth = $('#fc-dom-1').html();
        if (!Fullcalendar.trackingAjaxCalls.includes(_currentMonth)) {
          // console.log('## make Ajax call');

          // Get first & last dates. (for current month)
          var _allDays = $('td .fc-daygrid-day'),
              _from = '', _to = '';
          _allDays.each(function(index) {
            if ( !$(this).hasClass('fc-day-other') ) {
              if (_from === '') {
                _from = $( this ).data('date');
              } else {
                _to = $( this ).data('date');
              }
            }
          });

          // console.log( 'from : ' + _from );
          // console.log( 'to : ' + _to );

          Fullcalendar.ajaxGetEvents("calendarId", _from, _to);
        } else {
          // console.log('## Ajax response already exists');
        }

      } else {  // First call

        // console.log('####### classic context');
        Fullcalendar.ajaxGetEvents("calendarId", "", "");

      }
    },
    ajaxGetEvents: function (calendarId, from, to) {
      // console.log('ajaxGetEvents');
      var loader = $(".loader"),
        currentMonth = $('#fc-dom-1').html(),
        data = {
          action: "getOutlookEvents",
          calendar: calendarId,
          from: from,
          to: to,
          lib: "fullcalendar",
        };

      $.ajax({
        url: Config.ajax_url,
        data: data,
        type: "POST",
        beforeSend: function (xhr) {
          loader.show();
        },
        success: function (response) {
          // console.log(response.data.code);
          // console.log(response);

          if (response.data.code === "200") {
            // TODO : response
            var eventsToAdd = response.data.events;
            eventsToAdd.forEach(function (event) {
              // var _index = EvoCalendar.activeEvents.indexOf(event.id);
              // if (_index === -1) {
              // EvoCalendar.activeEvents.push(event.id);
              // $("#"+calendarId).evoCalendar('addCalendarEvent', event);
              // console.log('xx add event : ' + event.id);
              // }
              Fullcalendar.calendar.batchRendering(function () {
                Fullcalendar.calendar.changeView("dayGridMonth");
                Fullcalendar.calendar.addEvent(event);
              });
            });

            Fullcalendar.trackingAjaxCalls.push(currentMonth);
            // console.log( '#### update tracking list' );
          } else {
            console.log("error"); // TODO
          }
          loader.hide();
        },
      }); // end Ajax
    }
  };

  var CustomBooking = {
    currentCustomerId: "",
    currentProductId: "",
    has_selected_block : false,
    init: function () {
      // Autocompletion
      if ($(".search-customer .search #autocomplete").length) {
        CustomBooking.autocomplete(
          "customer",
          Config.cbooking_customers_search_data
        );
      }
      // if ($(".search-product .search #autocomplete").length) {
      //   CustomBooking.autocomplete('product', Config.cbooking_products_search_data);
      // }

      // New customer creation
      CustomBooking.initCreateCustomer();

      // Product
      $("#bookable_product_id").on("change", function (e) {
        // console.log('pid : ' + $(this).val());
        CustomBooking.currentProductId = $(this).val();
        CustomBooking.hideBookingCreationButton();
      });

      var resetButton = $(".cancel");
      resetButton.click(function (e) {
        e.preventDefault();
        var searchType = $(this).data("search-type");
        $(".search-" + searchType + " .search #autocomplete").val("");
        $(".search-" + searchType + " .search #" + searchType + "_id").val("");

        if (searchType === "product") {
          CustomBooking.currentProductId = "";
        } else {
          CustomBooking.currentCustomerId = "";
          $(this).addClass("d-none");
          $('#createCustomerButton').removeClass("d-none");
        }

        CustomBooking.hideBookingCreationButton();
      });

      CustomBooking.initBookingListeners();
    },
    autocomplete: function (searchType, searchData) {
      // SEARCH
      var search = $(".search-" + searchType + " .search #autocomplete");
      search
        .autocomplete({
          minLength: 0,
          source: searchData,
          // focus: function (event, ui) {
          //   search.val(ui.item.label);
          //   return false;
          // },
          classes: { "ui-autocomplete": "search-customer-ul" },
          select: function (event, ui) {
            search.val(ui.item.label);
            $(".search-" + searchType + " .search #" + searchType + "_id").val(
              ui.item.value
            );

            var _currentValue = ui.item.value;
            if (searchType === "product") {
              // $('.product-message').addClass('d-none');
              CustomBooking.currentProductId = _currentValue;
            } else {
              CustomBooking.currentCustomerId = _currentValue;
              $('.cancel').removeClass("d-none");
              $('#createCustomerButton').addClass("d-none");
            }

            CustomBooking.hideBookingCreationButton();
            return false;
          },
        })
        .autocomplete("instance")._renderItem = function (ul, item) {
          return $("<li>")
          .append(
            "<div class='autocomplete-" +
              searchType +
              "-item'>" +
              item.label +
              "</div>"
          )
          .appendTo(ul);
        };
      // END SEARCH
    },
    hideBookingCreationButton: function () {
      if (
        CustomBooking.currentProductId !== "" &&
        CustomBooking.currentCustomerId !== ""
      ) {
        $(".submit-button").removeClass("invisible");
      } else {
        $(".submit-button").addClass("invisible");
      }
    },
    initCreateCustomer: function () {
      // Submit customer creation form.
      $(document).on("click", ".create-customer-form .submit_new_customer", function (e) {
        e.preventDefault();

        var form = $(this).parents(".create-customer-form"),
          formData = $('.create-customer-form').serializeArray(),
          errors = CustomBooking.checkRequiredCustomerFields(formData);
          // email = form.find("#email").val();

        if (errors.length > 0) { // Has missing data.

          form.find(".message").html("Au moins un champ est manquant");
          // errors.forEach(function(field){
          //   $('#createCustomer #' + field).addClass('field-error');
          //   if (field === 'email') {
          //     if (field !== "" &&
          //       /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(field)
          //     ) {
          //       // form.find(".message").addClass("d-none");
          //     } else {
          //       form.find(".message").html("Adresse email invalide");
          //       // form.find(".message").removeClass("d-none");
          //     }
          //   }
          // });
          form.find(".message").removeClass("d-none");

          setTimeout(function() {
            form.find(".message").addClass("d-none");
          }, 5000);

        } else { // Has no missing data.

          // $('#createCustomer input').removeClass('field-error');
          var email = form.find("#email").val();
          if (email !== "" &&
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
          ) {
            form.find(".message").addClass("d-none");
            CustomBooking.ajaxCreateCustomer(formData);
          } else {
            // $('#createCustomer #email').addClass('field-error');
            form.find(".message").html("Adresse email invalide");
            form.find(".message").removeClass("d-none");

            setTimeout(function() {
              form.find(".message").addClass("d-none");
            }, 5000);
          }

        }
      });

      $(document).on("click", ".create-customer-form #use_same_address", function () {
        $('.use-different-address').toggleClass('d-none');
      });
    },
    ajaxCreateCustomer: function (formData) {
      var loader = $(".loader"),
        data = {
          action: "createCustomer",
          data: formData,
        };

      $.ajax({
        url: Config.ajax_url,
        data: data,
        type: "POST",
        beforeSend: function (xhr) {
          loader.show();
        },
        success: function (response) {
          // console.log(response);
          // console.log(response.data.code);

          var _form = $(".create-customer-form");
          _form.find(".message").html(response.data.message);
          _form.find(".message").removeClass("d-none");
          // console.log( Config.cbooking_customers_search_data );

          if (response.data.code === "200") {
            // Ajout du user dans le tableau "autocomplete"
            Config.cbooking_customers_search_data.push(response.data.search);

            // Préselectionné le nouveau user
            var _search = $(".search-customer .search #autocomplete");
            _search.val(response.data.search.label);
            $(".search-customer .search #customer_id").val(
              response.data.search.value
            );

            // Update current customer & buttons
            CustomBooking.currentCustomerId = response.data.search.value;
            $('.cancel').removeClass("d-none");
            $('#createCustomerButton').addClass("d-none");
            CustomBooking.hideBookingCreationButton();

            // Hide creation form
            $( "#createCustomerButton" ).trigger( "click" );
            window.scrollTo(0, 0);

          } else {
            console.log("error"); // TODO
          }
          loader.hide();
        },
      }); // end Ajax
    },
    initBookingListeners : function () {

      $.ajaxSetup({
        dataFilter: function (data, type) {
          // console.log( '########################## DATA FILTER' );
          try {
            var json = $.parseJSON(data);
            if (typeof json.html !== "undefined") {
              // console.log( json );
              // console.log('cost : ' + json.html.indexOf('woocommerce-Price-amount'));
              // console.log('error : ' + json.html.indexOf('booking-error'));

              var _selectedBlock = CustomBooking.has_selected_block;
              // console.log( '_selectedBlock : ' + _selectedBlock );

              var _enabled = false;
              if (json.html.indexOf('woocommerce-Price-amount') !== -1) { // Returns booking price.
                if (Config.cbooking_has_blocks && _selectedBlock) { // And has selected block (if necessary)
                  _enabled = true;
                  // console.log('Has blocks & has selected block');
                } else if (!Config.cbooking_has_blocks) {  // Or has no blocks (day, night, etc)
                  _enabled = true;
                  // console.log('Has no blocks');
                }
              }
              // console.log('_enabled : ' + _enabled);
              CustomBooking.disableBookingButton(!_enabled);

              // Update Product Addons section
              setTimeout(function () {
                var _cart = $( 'body' ).find( '#wc-bookings-booking-form .cart' );
                _cart.trigger( 'woocommerce-product-addons-update' );
              }, 500);
            }
          } catch(err) {
            // do nothing
          }
          return data;
        }
      });

      $(".wc-bookings-date-picker").on("date-selected", function (event, fdate) {
        // console.log('date selected');
        CustomBooking.has_selected_block = false;
        CustomBooking.disableBookingButton(true);
      });

      $(".block-picker").on("click", "a", function(){
        // console.log('block selected');
        CustomBooking.has_selected_block = true;
        CustomBooking.disableBookingButton(true);
      });

      $('#wc_bookings_field_persons').on('input', function() {
        // Update tourist tax.
        var nb_persons = $(this).val();
        // console.log('nb persons : ' + nb_persons);
        Booking.tourist_tax_multiplier = nb_persons;
        Booking.updateTouristTaxMultiplier();
        // Disable booking button.
        CustomBooking.disableBookingButton(true);
      });

      $("#createCustomerButton").on("click", function(){
        if (!$('#createCustomer').hasClass('show')) {
          setTimeout(function() {
            var _anchor = '#create-customer-form';
            Fn.goTo(_anchor, 1000, true);
          }, 500);
        }
      });

      $(window).keydown(function(event){
        if(event.keyCode === 13) { // Enter
          event.preventDefault();
          return false;
        }
      });
    },
    disableBookingButton : function (disabled) {
      var _bookButton = $('input[name=create_booking_2]');
      if (disabled) {
        _bookButton.addClass('disabled');
        _bookButton.prop("disabled", true);
      } else {
        _bookButton.removeClass('disabled');
        _bookButton.prop("disabled", false);
      }
    },
    checkRequiredCustomerFields : function (formData) {

      var _accountReqFields = ['last_name', 'first_name', 'email'],
          _addressReqFields = ['billing_phone', 'billing_address_1', 'billing_city', 'billing_postcode', 'billing_country', 'shipping_phone', 'shipping_address_1', 'shipping_city', 'shipping_postcode', 'shipping_country'],
          _useSameAddress = false,
          _errorReqFields = [];
      // return _errorReqFields; // NOTE : TEMP

      // Use same address ?
      formData.forEach(function(field){
        if (field.name === 'use_same_address' && field.value === 'on') {
          _useSameAddress = true;
        }
      });
      // console.log('_useSameAddress : ' + _useSameAddress);

      // Check all required fields.
      formData.forEach(function(field){

        if (_accountReqFields.includes(field.name) && field.value === '') {
          _errorReqFields.push( field.name );
          return;
        }

        if (field.name.indexOf("billing") >= 0) {
          if (_addressReqFields.includes(field.name) && field.value === '') {
            _errorReqFields.push( field.name );
            return;
          }
        }

        if (field.name.indexOf("shipping") >= 0 && !_useSameAddress) {
          if (_addressReqFields.includes(field.name) && field.value === '') {
            _errorReqFields.push( field.name );
            return;
          }
        }
      });

      // console.log( _errorReqFields );
      return _errorReqFields;
    }
  };

  var Sage = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages

        Modules.init();
        Ajax.init();
        var bodyDom = $("body");
        if (!bodyDom.hasClass("page-template-template-landing")) {
          Fn.header();
        }
        Fn.checkSitckyContent();
        window.WebFontConfig = {
          google: {
            api: "https://fonts.googleapis.com/css2",
            families: ["Montserrat:wght@300;400;500;600&display=swap"],
          },
          custom: {
            families: [
              "PassengerDisplay-Italic",
              "PassengerDisplay-Light",
              "PassengerDisplay-Regular",
              "PassengerDisplay-Light-Italic",
            ],
          },
        };
        (function () {
          var wf = document.createElement("script");
          wf.src = "https://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js";
          wf.type = "text/javascript";
          wf.async = "true";
          var s = document.getElementsByTagName("script")[0];
          s.parentNode.insertBefore(wf, s);
        })();

        Fn.menuGiscours();
        Fn.fakeShare();

        // Cookie mobile
        $(".load-mobile-cookie").click(function (e) {
          e.preventDefault();
          $(".mobile-close").click();
          $("#cookie-law-info-again").click();
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        Account.init();
      },
    },
    // Home page
    page_template_template_home: {
      init: function () {
        // JavaScript to be fired on the home page
        Fn.moduleFullWidth();
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
        Fn.header();
        AOS.init({
          once: true,
        });
        var homeVideoH = $("section.video").outerHeight(),
          body = $("body");

        $(window).scroll(function () {
          var currentScroll = $(window).scrollTop();
          if (currentScroll >= homeVideoH) {
            // show header
            body.addClass("show-header");
          } else {
            // hide header
            body.removeClass("show-header");
          }
        });

        if ($(".punchline").length) {
          // Go to content
          $(".scroll-button svg").click(function (e) {
            e.preventDefault();
            // Fn.goTo(('.test'),750,true);
            $("html, body").animate(
              { scrollTop: $(".punchline").offset().top - 25 },
              1000
            );
          });
        }
      },
    },
    page_template_template_guide: {
      init: function () {
        Slider.create(".guide-slider");
        AOS.init({
          once: true,
        });

        $(".scroll-button svg").click(function (e) {
          e.preventDefault();
          Fn.goTo(".guide", 1000, true);
        });
      },
    },
    page_template_template_wines: {
      init: function () {
        AOS.init({
          once: true,
        });
      },
    },
    single_wine: {
      init: function () {
        var _tab_presentation = "tab-" + Config.js_translations.presentation,
          _tab_millesimes = "tab-" + Config.js_translations.millesimes;

        AOS.init({
          once: true,
        });
        Fn.hashActiveTab();

        var isTweenActive = false,
          body = $("body"),
          toTop,
          to;
        $('a[data-toggle="tab"]').on("shown.bs.tab", function (event, i) {
          if (
            $(event.target).attr("id") === _tab_millesimes &&
            !isTweenActive
          ) {
            // Enable tween when tab-millesimes is shown (once)
            Fn.tween(true);
            Fn.fadeDate();
            isTweenActive = true;
            var fixmeTop = $(".mobile-vintage-selector").offset().top;
            // Handle mobile vintage selector
            $(window).scroll(function () {
              var currentScroll = $(window).scrollTop();
              if (currentScroll >= fixmeTop - 90) {
                $(".mobile-vintage-selector").css({
                  position: "fixed",
                  top: "75px",
                  width: "100%",
                  left: "0",
                });
                $(".module-year").first().css("padding-top", "120px");
              } else {
                $(".mobile-vintage-selector").css({
                  position: "static",
                });
                $(".module-year").first().css("padding-top", "0");
              }
            });
          }

          if ($(event.target).attr("id") === _tab_millesimes) {
            $(".paginations").removeClass("d-none");
            // Fn.goTo(_tab_millesimes, 1000, true);
            to = _tab_millesimes.replace("tab-", "");

            // var breakpoint = window.matchMedia( '(max-width:62em)' ); //992px
            // if ( breakpoint.matches === true ){
            //   toTop = $('#'+to).offset().top - ($('.header').height()+10);
            // }else{
            // }
            toTop = $("#" + to).offset().top - ($(".header").height() + 10);
          } else if ($(event.target).attr("id") === _tab_presentation) {
            $(".paginations").addClass("d-none");
            to = _tab_presentation.replace("tab-", "");
            toTop = $("#" + to).offset().top - ($(".header").height() + 10);
          }
          $("html, body").animate({ scrollTop: toTop }, 1000);
          console.log(_tab_millesimes);
          console.log(_tab_millesimes.replace("tab-", ""));
          console.log(_tab_presentation);
          console.log(_tab_presentation.replace("tab-", ""));
        });

        // Other vintage menu
        var menu = $(".mobile-vintage");
        $(".open-vintage").click(function (e) {
          e.preventDefault();
          menu.addClass("active");
        });

        $(".close-vintage").click(function (e) {
          e.preventDefault();
          menu.removeClass("active");
        });

        $(".mobile-vintage .other-link").click(function (e) {
          e.preventDefault();
          var _this = $(this),
            target = _this.data("target"),
            toTop = $("#" + target).offset().top - $(".header").height() - 90;
          menu.removeClass("active");
          $("html, body").animate({ scrollTop: toTop }, 1000);
        });
      },
    },
    page_template_template_guide_details: {
      init: function () {
        Fn.moduleFullWidth();
        AOS.init({
          once: true,
        });

        // Other places sidebar
        var menu = $(".wrapper-sidebar");
        $(".open-other-places").click(function (e) {
          e.preventDefault();
          menu.addClass("active");
        });

        $(".close-sidebar").click(function (e) {
          e.preventDefault();
          menu.removeClass("active");
        });
      },
    },
    page_template_template_content: {
      init: function () {
        Fn.moduleFullWidth();
        AOS.init({
          once: true,
        });

        // Other places sidebar
        var menu = $(".wrapper-sidebar");
        $(".open-other-places").click(function (e) {
          e.preventDefault();
          menu.addClass("active");
        });

        $(".close-sidebar").click(function (e) {
          e.preventDefault();
          menu.removeClass("active");
        });
      },
    },
    page_template_template_ajdomaine: {
      init: function () {
        Fn.moduleFullWidth();
        AOS.init({
          once: true,
        });
      },
    },
    page_template_template_portraits: {
      init: function () {
        var currentUrl = window.location.href.split("#");
        // Display / hide portrait content.
        $(".discover-portrait").click(function (e) {
          e.preventDefault();
          var _this = $(this),
            _portraitId = _this.data("portrait"),
            _portraitContent = $("#portrait-content-" + _portraitId);

          _this.toggleClass("active");

          if (_portraitContent.hasClass("hidden")) {
            _portraitContent.slideDown("normal", function () {
              $(this)
                .removeClass("hidden")
                .find(".sidebar-ref")
                .removeClass("no-sticky");
            });
          } else {
            _portraitContent.slideUp("fast", function () {
              $(this)
                .addClass("hidden")
                .find(".sidebar-ref")
                .addClass("no-sticky");
            });
          }
        });

        if (currentUrl[1] !== "") {
          $("#" + currentUrl[1])
            .find(".discover-portrait")
            .trigger("click");
        }
      },
    },
    page_template_template_agenda: {
      init: function () {
        Fn.eventsIsotope();

        // Date sidebar
        var menu = $(".wrapper-sidebar");
        $(".event-filters-btn").click(function (e) {
          e.preventDefault();
          menu.addClass("active");
        });

        $(".close-sidebar").click(function (e) {
          e.preventDefault();
          menu.removeClass("active");
        });
      },
    },
    page_template_template_retailers: {
      init: function () {
        Map.init();
        Fn.autocomplete();
      },
    },
    page_template_template_history: {
      init: function () {
        Fn.tween(false);
        Fn.fadeDate();
      },
    },
    page_template_template_plan: {
      finalize: function () {
        var sidebar = $(".wrapper-sidebar.plan");

        // Close sidebar & dezoom on desktop
        $(".close-sidebar, .plan .bg").click(function (e) {
          e.preventDefault();
          sidebar.removeClass("active");

          if (!$.imageMapProIsMobile()) {
            $.imageMapProZoomOut("PlanGiscours");
            setTimeout(function () {
              $.imageMapProZoomOut("PlanGiscours");
            }, 800);
          }
        });

        // Formalize guide details datas & inject in sidebar
        function formalizeMapGuideDatas(shapeTitle) {
          var plans_data = Config.plans_data,
            slugifiedShapeTitle = string_to_slug(shapeTitle),
            formalizedDatas = {};
          $.each(plans_data, function (labelKey, datas) {
            if (labelKey === slugifiedShapeTitle) {
              $.each(datas, function (key, value) {
                formalizedDatas[key] = value;
              });
            }
          });

          // inject guide details datas if exists
          if (!$.isEmptyObject(formalizedDatas)) {
            for (var key in formalizedDatas) {
              if (key !== "plan_image" && key !== "plan_link") {
                sidebar.find("#" + key).html(formalizedDatas[key]);
              } else if (key === "plan_link") {
                if (formalizedDatas[key] !== "") {
                  sidebar.find("#" + key).show();
                  sidebar.find("#" + key).attr("href", formalizedDatas[key]);
                } else {
                  sidebar.find("#" + key).hide();
                }
              } else {
                sidebar.find("#" + key).attr("src", formalizedDatas[key]);
              }
            }
            setTimeout(function () {
              sidebar.addClass("active");
            }, 1000);
          } else {
            console.log("not datas found for : " + shapeTitle);
          }

          return formalizedDatas;
        }

        $.imageMapProInitialized = function (imageMapName) {
          // Map initialized
          if (
            imageMapName === "PlanGiscours" ||
            imageMapName === "PlanGiscoursUK"
          ) {
            $.imageMapProEventClickedShape = function (
              imageMapName,
              shapeTitle
            ) {
              formalizeMapGuideDatas(shapeTitle);
            };

            if ($.imageMapProIsMobile()) {
              $.imageMapProZoomIn("PlanGiscours");
            }

            $(".select-mobile-location").click(function (e) {
              e.preventDefault();
              $(".detached-menu").slideToggle();
            });

            $(".imp-ui")
              .appendTo(".zoom-wrapper")
              .prepend('<div class="zoom-title order-2 px-10">Zoom</div>');
            $(".imp-ui-zoom-button-zoom-out").addClass("order-1");
            $(".imp-ui-zoom-button-zoom-in").addClass("order-3");
            $(".imp-ui-scroll-message-wrap").remove();

            // Add an event listener to map buttons list
            $(".imp-shapes-menu-scroll-wrap .imp-shapes-menu-shape-title").on(
              "click",
              function (e) {
                formalizeMapGuideDatas($(this).data("imp-content"));
              }
            );
          }
        };
      },
    },
    single_product: {
      init: function () {
        Booking.init();
      },
    },
    single_offer: {
      init: function () {
        $(".btn-devis").click(function (e) {
          e.preventDefault();
          setTimeout(function () {
            var section = $(".contact-title");
            $("html,body").animate(
              { scrollTop: section.offset().top - 85 },
              "slow"
            );
          }, 500);
        });

        $(".scroll-button svg").click(function (e) {
          e.preventDefault();
          var _nextContent = $("body").children("section").eq(1);
          Fn.goTo(_nextContent, 1000, true);
        });
      },
    },
    woocommerce_page: {
      init: function () {
        // var body = $( 'body' );
        // $( document ).ajaxComplete( function() {
        //   if ( body.hasClass( 'woocommerce-checkout' ) || body.hasClass( 'woocommerce-cart' ) ) {
        //     $( 'html, body' ).stop();
        //   }
        // } );
      },
    },
    tax_product_cat: {
      init: function () {
        // Go to content
        $(".scroll-button svg").click(function (e) {
          e.preventDefault();
          var _nextContent = $(".module-text-photo"); // No bookable product.
          if ($(".offer-list").length > 0) {
            // Bookable product.
            _nextContent = $(".offer-list");
          }
          Fn.goTo(_nextContent, 1000, true);
        });
      },
    },
    page_template_template_landing: {
      init: function () {
        // Go to content
        $(".scroll-button svg").click(function (e) {
          e.preventDefault();
          $("html, body").animate(
            { scrollTop: $(".coming-soon").offset().top },
            1000
          );
        });
      },
    },
    page_template_template_espacepro: {
      init: function () {
        // Download pro file. Use original url if optimole is active.
        $(".dl-button").click(function (e) {
          e.preventDefault();
          var _fileUrl = $(this).attr("href");
          if (typeof $(this).data("original") !== "undefined") {
            _fileUrl = Config.uploads_folder + $(this).data("original");
          }
          Fn.download_file(_fileUrl, null);
        });
        // Open pro file in new tab with original url if optimole is active.
        $(".optimole-image").click(function (e) {
          e.preventDefault();
          var _fileUrl = Config.uploads_folder + $(this).data("original");
          window.open(_fileUrl, "_blank");
        });
      },
    },
    page_template_template_booking: {
      // DEBUG_EVO & DEBUG_FULL
      init: function () {
        if ($("#calendar").length) {
          Fullcalendar.init("calendar");
        }
        CustomBooking.init();
        Booking.init();
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        }
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
